import { axiosMockAdapterInstance } from "apis";
import { getResponseData } from "mocksdata/index";
import dayjs from "dayjs";

const admin = [
  {
    email: "minhbn@sotanext.com",
    role: "superadmin",
  },
  {
    email: "minhbn1@sotanext.com",
    role: "admin",
  },
  {
    email: "minhbn2@sotanext.com",
    role: "admin",
  },
  {
    email: "minhbn3+1@sotanext.com",
    role: "customer-support",
  },
];

const roles = ["superadmin", "admin", "customer-support"];

export const onGetAllSystemAdmin = (query) => {
  console.log(query);
  axiosMockAdapterInstance.onGet("/roles/users").reply(() => {
    console.log(query);
    const { page, limit, search = "", roles = "" } = query;
    const data = admin.filter(
      (admin) =>
        admin.email.toLowerCase().indexOf(search.trim().toLowerCase()) !== -1 &&
        (roles ? admin.role === roles : true),
    );

    console.log(data);
    console.log("zz", data.slice((page - 1) * limit, page * limit));
    // .slice((page - 1) * limit, page * limit);
    return [
      200,
      {
        data: data.slice((page - 1) * limit, page * limit),
        statusCode: 200,
        time: dayjs().toISOString(),
        total: admin.length,
      },
    ];
  });
};

export const onGetAllRoles = () => {
  axiosMockAdapterInstance.onGet("/roles").reply(() => {
    return [200, getResponseData(roles)];
  });
};
